
  let products = JSON.parse(localStorage.getItem("giftProducts") || "[]"); 
  localStorage.setItem("giftProducts", JSON.stringify(products));
  
   const all_products = document.querySelectorAll(".collection-grid-cust .product-item.card[data-var-id]");

    all_products.forEach((product) => {
      const product_var_id = product.getAttribute("data-var-id");
      const checkbox = product.querySelector(".gift-checkbox");
      checkbox.checked = false;  
    });
  
  async function getproduct(This){
    const box = document.querySelector(".gewuerzbox-panel .discount_text");
    const card_product = This.closest(".product-item.card");  
    const card_handle = card_product.getAttribute("data-handle");        
    const now = Date.now();
    const var_id = card_product.getAttribute("data-var-id");       
    const all_products = document.querySelectorAll(".collection-grid-cust .product-item.card[data-var-id]");

    all_products.forEach((product) => {
      const product_var_id = product.getAttribute("data-var-id");
      const checkbox = product.querySelector(".gift-checkbox");

      if (checkbox && product_var_id !== var_id) checkbox.checked = false;  
    });

    
    window.data_wrapp = document.querySelector(".slot_products-gift");
    if (window.data_wrapp) {
        window.data_wrapp.innerHTML = "";
    }        
    if(var_id){
        const data_wrapp_info = await selectedProductShow(card_handle, now, var_id);
        if (data_wrapp_info) {  
            window.data_wrapp.insertAdjacentHTML('beforeend',data_wrapp_info.outerHTML);
            window.data_wrapp.querySelector(".gb-item.is_gift_temp[data-var-id]");     
            box.classList.remove("hidden");
        }
    }
  }


  async  function selectedProductShow(handle, currentTime, var_id ) {
    try {
      const urllink =  `/products/${handle}?variant=${var_id}&view=friend-gift`;
      const response = await fetch(urllink);
      const productHTML = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(productHTML, 'text/html');
      const mainDivEl = doc.querySelector('.gb-item');      

      if (mainDivEl) {
          mainDivEl.setAttribute("data-handle", handle);  
          mainDivEl.setAttribute("currentTime",currentTime);
        return mainDivEl;
      }      
      if(mainDivEl){
        return mainDivEl;
      }else{
        return null;
      }
      return     
    } catch (error) {
      console.error('Error fetching product info:', error);
      return null;
    }
  } 


  function clearcart(){
      fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        "Accept": "application/json"
      }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error("Failed to clear cart");
        }

        return response.json();
      })
      .then(() => {
        // Cart is now empty, add new product
        return customAddToCart(product, true);
      })
      .catch(error => {
        console.error("Cart error:", error);
      });
  }


  function BundleAddToCart(Button) {
    const active_slot = document.querySelector(".gb-box-section .gb-item .gift-text-box")?.value;    
    const item = document.querySelector(".gb-item");
    if (!item) return;

    const productVarId = item.dataset.varId;  
    const alreadyExists = products.some(product => product.id === productVarId);
    products = [];
    if (alreadyExists) return;  
    const customProperties = {"Bundle Item": active_slot};            
    products.push({id: productVarId,quantity: 1,properties: customProperties});

    clearcart();    
    localStorage.setItem("giftProducts", JSON.stringify(products));  
    if (products.length > 0) {
        customAddToCart({ items: products }, true);
        localStorage.removeItem("giftProducts");
    }
  }


  function customAddToCart(product) {        
    fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { "Accept": "application/json", "Content-Type": "application/json" },
        body: JSON.stringify(product)
    })
    .then(response => response.json())
    .then(response => console.log("Response:", response))
    .catch(error => console.error('Error:', error))
    .finally(() => {    
             window.location.href = "/checkout?discount=FriendGift";
    });
  }